<div class="submit-container">
  <h1>How to Submit</h1>
  <p>
    The DOME registry provides users with the opportunity to contribute annotations using the DATA Stewardship Wizards
    tool. These submitted annotations will undergo a manual review process, ultimately leading to publication.
  </p>
  <a href="https://www.youtube.com/watch?v=fmVppa9ESw0&ab_channel=BioComputingUP" class="tutorial-button">
    Visit Tutorial
    <img src="assets/thin-arrow-right-icon.svg" alt="Right arrow" class="right-small-arrow">
  </a>
</div>
